// extracted by mini-css-extract-plugin
module.exports = {"time":"_5b10bb2305--time--yJHIk","icon":"_5b10bb2305--icon--sUoBI"};